module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }